import { useEffect, useState } from "react";
import { ClipboardCheck, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { apiErrorMessage } from "./hierarchy";

export default function Monitorings() {
  const [cycles, setCycles] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/device-monitoring/cycles", {
        params: { status: "open", page_size: 20 },
      });
      setCycles(r.data.items || []);
    } catch (err) {
      setCycles([]);
      toast.error(apiErrorMessage(err, "Erro ao carregar monitoramentos."));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="space-y-4">
      <h3 className="font-semibold">Monitoramentos em Aberto</h3>

      {loading ? (
        <div className="flex justify-center py-12">
          <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
        </div>
      ) : (
        <div className="grid gap-4">
          {cycles.map((c) => (
            <div
              key={c.id}
              className="rounded-lg border border-border bg-card p-4"
            >
              <div className="flex items-center gap-3 mb-2">
                <ClipboardCheck className="h-5 w-5 text-primary" />
                <h4 className="font-medium">{c.client_name}</h4>
                <span className="text-xs text-muted-foreground">
                  {c.unit_name}
                </span>
                <span
                  className={`ml-auto text-xs px-2 py-1 rounded ${
                    c.status === "CONCLUIDO"
                      ? "bg-green-100 text-green-700"
                      : c.status === "PENDENTE"
                      ? "bg-amber-100 text-amber-700"
                      : "bg-blue-100 text-blue-700"
                  }`}
                >
                  {c.status}
                </span>
              </div>
              <div className="grid grid-cols-4 gap-4 text-sm">
                <div>
                  <span className="text-muted-foreground">Previstos:</span>{" "}
                  {c.expected_count}
                </div>
                <div>
                  <span className="text-muted-foreground">Monitorados:</span>{" "}
                  {c.monitored_count}
                </div>
                <div>
                  <span className="text-muted-foreground">Cobertura:</span>{" "}
                  {c.coverage_pct}%
                </div>
                <div>
                  <span className="text-muted-foreground">Semana:</span>{" "}
                  {c.week_start}
                </div>
              </div>
            </div>
          ))}
          {cycles.length === 0 && (
            <div className="text-center py-12 text-muted-foreground">
              Nenhum monitoramento em aberto.
            </div>
          )}
        </div>
      )}
    </div>
  );
}
